<script>
    import Drawer from '@fno/component/layout/Drawer.svelte'
    import HelloMenu from './HelloMenu.svelte'
    import { Button } from 'sveltestrap'
    import Icon from 'svelte-awesome'
    import { bars } from 'svelte-awesome/icons'

    export let asr
    export let schoolId

    let open
    let scrim
    let staticAssetPrefix = (window.fanxVersion && window.fanxVersion.urlPrefix) || '/'
    let windowLocationPath = window.location.pathname
</script>

<style>
    div[slot='panel'] {
        min-height: 100%;
    }
    /*
    NOTE: This is a hack to override the Bootstrap 3 styles, which were
    causing the navbar to be centered (using the old clear/float trick).
    Once we are off 3, or if we've managed to silo 3 away by itself more
    carefully, we can ditch these.
    */
    div[slot='content'] :global(nav.navbar div.container-fluid:before) {
        display: initial !important;
        content: initial !important;
    }
    div[slot='content'] :global(nav.navbar div.container-fluid:after) {
        display: initial !important;
        content: initial !important;
        clear: initial !important;
    }

    :global(html) {
        background-color: #f2f2f2 !important;
    }

    :global(.fno-onboarding-menu) {
        background-color: #077175 !important;
        color: #fff;
    }

    :global(.fno-onboarding-menu a) {
        color: #fff;
        font-weight: bold;
    }
</style>

<Drawer bind:open bind:scrim bgColor="#077175" fontColor="#fff">
    <div slot="panel">
        <HelloMenu {asr} {schoolId} />
    </div>
    <div slot="content" class="bg-light-color">
        {#if !open || scrim}
            <nav class="navbar" id="navbarNav">
                <div class="container-fluid">
                    <a class="navbar-brand" href={windowLocationPath}>
                        <img
                            src="{staticAssetPrefix}img/fromnowon-logo-02.png"
                            alt="From Now On"
                            height="54"
                            class="d-inline-block align-top"
                        />
                    </a>
                    <Button on:click={() => (open = true)}>
                        <Icon data={bars} />
                    </Button>
                </div>
            </nav>
        {/if}
        <div class="container px-0">
            <uiView />
        </div>
    </div>
</Drawer>
